import "core-js/modules/es.object.assign";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
var block = {
  display: 'block'
};
var layout = {
  display: 'flex',
  flexWrap: 'nowrap'
};
var wrap = {
  flexWrap: 'wrap'
};
var inline = {
  display: 'inline-flex'
};
var flex = {
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto'
};
var basisAuto = {
  flexBasis: 'auto'
};
var basisZero = {
  flexBasis: '0%'
};
var basisMax = {
  flexBasis: '100%'
};
var flexNone = {
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto'
};
var noShrink = {
  flexShrink: 0
};
var shrink = {
  flexShrink: 1
};
var relative = {
  position: 'relative'
};
var absolute = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var horizontal = Object.assign({}, layout, {
  flexDirection: 'row'
});
var horizontalReverse = Object.assign({}, layout, {
  flexDirection: 'row-reverse'
});
var vertical = Object.assign({}, layout, {
  flexDirection: 'column'
});
var verticalReverse = Object.assign({}, layout, {
  flexDirection: 'column-reverse'
});
var alignStart = {
  alignItems: 'flex-start'
};
var alignCenter = {
  alignItems: 'center'
};
var alignEnd = {
  alignItems: 'flex-end'
};
var alignStretch = {
  alignItems: 'stretch'
};
var selfAlignStart = {
  alignSelf: 'flex-start'
};
var selfAlignCenter = {
  alignSelf: 'center'
};
var selfAlignEnd = {
  alignSelf: 'flex-end'
};
var selfAlignStretch = {
  alignSelf: 'stretch'
};
var justifyStart = {
  justifyContent: 'flex-start'
};
var justifyCenter = {
  justifyContent: 'center'
};
var justifyEnd = {
  justifyContent: 'flex-end'
};
var justifyBetween = {
  justifyContent: 'space-between'
};
var justifyAround = {
  justifyContent: 'space-around'
};
var hidden = {
  display: 'none'
};
var invisible = {
  visibility: 'hidden'
};
var centered = Object.assign({}, layout, alignCenter, justifyCenter);
export default {
  block: block,
  hidden: hidden,
  invisible: invisible,
  centered: centered,
  relative: relative,
  absolute: absolute,
  layout: layout,
  wrap: wrap,
  inline: inline,
  flex: flex,
  flexNone: flexNone,
  basisAuto: basisAuto,
  basisZero: basisZero,
  basisMax: basisMax,
  shrink: shrink,
  noShrink: noShrink,
  horizontal: horizontal,
  horizontalReverse: horizontalReverse,
  vertical: vertical,
  verticalReverse: verticalReverse,
  alignStart: alignStart,
  alignCenter: alignCenter,
  alignEnd: alignEnd,
  alignStretch: alignStretch,
  selfAlignStart: selfAlignStart,
  selfAlignCenter: selfAlignCenter,
  selfAlignEnd: selfAlignEnd,
  selfAlignStretch: selfAlignStretch,
  justifyStart: justifyStart,
  justifyCenter: justifyCenter,
  justifyEnd: justifyEnd,
  justifyBetween: justifyBetween,
  justifyAround: justifyAround
};